var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVehiclesActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "veh\\xEDculos_main",
    "data-name": "veh\\xEDculos main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_207",
    "data-name": "Rect\\xE1ngulo 207",
    width: 34,
    height: 34,
    transform: "translate(767 744)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_30",
    "data-name": "Rect\\xE1ngulo 30",
    width: 30.578,
    height: 29.935,
    fill: "#85af26"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_21",
    "data-name": "Enmascarar grupo 21",
    transform: "translate(-767 -744)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30",
    transform: "translate(768.711 746.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_29",
    "data-name": "Grupo 29",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_43",
    "data-name": "Trazado 43",
    d: "M27.972,12.381v-.048h2.606V5.6H27.972l0-.982c0-.719,0-1.438-.008-2.157A2.387,2.387,0,0,0,25.459,0C18.446,0,11.6,0,5.1,0A2.373,2.373,0,0,0,2.618,2.445c0,.443,0,.887,0,1.33V5.61H0v6.733H2.607l.009,9.207q0,.417,0,.834c0,.564,0,1.128,0,1.692a2.4,2.4,0,0,0,2.488,2.412h.164v.332c0,.472,0,.929,0,1.386A1.678,1.678,0,0,0,7.01,29.926c.473.006.954.008,1.451.008.459,0,.932,0,1.423-.007A1.7,1.7,0,0,0,11.65,28.2c.007-.4.005-.794,0-1.191,0-.165,0-.33,0-.494h7.274V26.8c0,.444,0,.881,0,1.318a1.71,1.71,0,0,0,1.847,1.815c.82,0,1.641,0,2.461,0h.154a1.71,1.71,0,0,0,1.918-1.865c0-.421,0-.842,0-1.267v-.3a2.481,2.481,0,0,0,1.837-.623,2.691,2.691,0,0,0,.832-2.066c-.027-2.713-.019-5.472-.011-8.141q0-1.642.007-3.284M28,10.823V7.1h1.047v3.725Zm-4.22,16.3c0,.356,0,.712,0,1.068,0,.231-.092.232-.193.233-.935.01-1.889.01-2.917,0-.168,0-.192-.087-.194-.171-.01-.479-.008-.952-.006-1.452q0-.149,0-.3h3.313ZM10.1,28.295c0,.035,0,.129-.169.13-1.19.008-2.1.008-2.95,0-.109,0-.172-.032-.175-.184-.008-.474-.006-.947,0-1.434v-.3h3.306l0,.294c0,.514.006,1-.011,1.493m16.326-8.149q0,1.9,0,3.792c0,.726-.327,1.051-1.06,1.051H5.209c-.721,0-1.057-.325-1.058-1.021q0-2.524,0-5.049V17.039H26.428ZM4.184,5.819H14.5v9.672H4.184Zm11.9.012H26.406V15.49H16.085Zm9.3-4.332c.721,0,1.043.318,1.045,1.03q0,.462,0,.925v.829H4.154q0-.2,0-.4c0-.551-.009-1.071.01-1.6A.841.841,0,0,1,5,1.5c.062,0,.123,0,.2,0H25.383m-22.8,9.332H1.537V7.124H2.581Z",
    transform: "translate(0 0)",
    fill: "#85af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_44",
    "data-name": "Trazado 44",
    d: "M30.906,92.4h.02a2.517,2.517,0,0,0,2.54-2.447,2.409,2.409,0,0,0-.727-1.746,2.552,2.552,0,0,0-1.793-.75H30.93A2.5,2.5,0,0,0,28.412,89.9a2.438,2.438,0,0,0,.721,1.771,2.519,2.519,0,0,0,1.773.734m-.964-2.461a.96.96,0,0,1,.295-.7,1,1,0,0,1,.7-.285h.008a.993.993,0,0,1,.695.293.952.952,0,0,1,.289.686.994.994,0,0,1-1,.97h0a.981.981,0,0,1-.988-.966",
    transform: "translate(-22.257 -68.94)",
    fill: "#85af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_45",
    "data-name": "Trazado 45",
    d: "M91.886,92.4h.058a2.537,2.537,0,0,0,1.747-.684,2.431,2.431,0,0,0,.774-1.739,2.506,2.506,0,0,0-2.483-2.522,2.548,2.548,0,0,0-1.792.7,2.436,2.436,0,0,0-.779,1.748,2.505,2.505,0,0,0,2.475,2.5m.045-1.493a.975.975,0,1,1,.015-1.95h.005a.987.987,0,0,1,.69.283.951.951,0,0,1,.3.684h0a.97.97,0,0,1-.3.7.988.988,0,0,1-.706.279",
    transform: "translate(-70.041 -68.939)",
    fill: "#85af26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_29",
    "data-name": "Rect\\xE1ngulo 29",
    width: 5.897,
    height: 1.477,
    transform: "translate(12.341 20.262)",
    fill: "#85af26"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVehiclesActive);
export default __webpack_public_path__ + "static/media/icon_vehicles_active.7d3d4e1dfb465c2fa2e8c67ab20fc70c.svg";
export { ForwardRef as ReactComponent };